import { useIntl } from 'react-intl'
import type { TextFieldTypes } from 'react-md'
import {
	DataTable,
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
	TextField,
} from 'react-md'
import { formatCurrency } from 'util/formatStrings'
import styled from 'styled-components'
import { invoicePaymentProductsHeaders } from './constants'
import {
	billingBasisMessage,
	unitMessage,
} from 'ui/ManagerFinance/utils/messages'
import type { MeterReadingInvoiceRow } from './types'

const Content = styled.div`
	overflow: auto;
`

type Props = {
	invoiceRows: MeterReadingInvoiceRow[]
}

const InvoicePaymentProductsTable = ({ invoiceRows }: Props) => {
	const intl = useIntl()

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{invoicePaymentProductsHeaders
					.filter((h) => h.show)
					.map((header) => (
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
			</TableRow>
		)
	}

	const getValue = (row: MeterReadingInvoiceRow, key: string, type: string) => {
		let value = row[key]

		if (type === 'billingBasis') {
			return billingBasisMessage(intl, value)
		} else if (type === 'unitMessage') {
			return unitMessage(intl, row.billingBasis)
		} else {
			return value || ''
		}
	}

	const renderColumns = (row: MeterReadingInvoiceRow) => {
		return invoicePaymentProductsHeaders.map((header) => {
			const { show, key, type, editable } = header

			if (!show) return null

			const value = getValue(row, key, type)
			if (editable) {
				return (
					<TableColumn key={key}>
						<TextField
							key={key}
							id={key}
							floating
							lineDirection="center"
							fullWidth
							value={value}
							onChange={
								() => {}
								//TODO: (value) => handleInputChange(value, key, uuid, type)
							}
							type={(type as TextFieldTypes) || undefined}
						/>
					</TableColumn>
				)
			} else {
				return <TableColumn key={key}>{value}</TableColumn>
			}
		})
	}

	const renderSelectedPaymentProducts = () => {
		return invoiceRows.map((row) => {
			return (
				<TableRow key={row.paymentProductUUID}>
					{renderColumns(row)}
					{/*<TableColumn key={'delete'}>
							<Button icon onClick={() => deleteRow(uuid)}>
								delete
							</Button>
						</TableColumn>*/}
				</TableRow>
			)
		})
	}

	return (
		<Content>
			<DataTable plain>
				<TableHeader>{renderTableHeaders()}</TableHeader>
				<TableBody>
					<>
						{renderSelectedPaymentProducts()}
						<TableRow key={'total'}>
							<TableColumn>
								<b>
									{intl.formatMessage({
										defaultMessage: 'Yhteensä',
										description: 'Table column for invoice total.',
									})}
								</b>
							</TableColumn>
							<TableColumn
								colSpan={invoicePaymentProductsHeaders.length - 4}
							></TableColumn>
							<TableColumn>
								<b>
									{formatCurrency(
										invoiceRows.reduce(
											(acc, { price, quantity }) =>
												acc + (price || 0) * (quantity || 0),
											0,
										),
									)}
								</b>
							</TableColumn>
							<TableColumn>
								<b>
									{formatCurrency(
										invoiceRows.reduce(
											(acc, { priceWithVat, quantity }) =>
												acc + (priceWithVat || 0) * (quantity || 0),
											0,
										),
									)}
								</b>
							</TableColumn>
						</TableRow>
					</>
				</TableBody>
			</DataTable>
		</Content>
	)
}

export default InvoicePaymentProductsTable
